export const allowedOrigins = [import.meta.env.VITE_AUTH_APP_URL];
